import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';
import { PERSISTENCE_TYPE } from 'modules/taboola-common-frontend-modules/storage/persistenceType';

export const ACCOUNT_ID = 'accountId';

export const useSelectedAccountId = queryParamHookFactory(ACCOUNT_ID, {
    persist: PERSISTENCE_TYPE.LOCAL_STORAGE,
});
